import React from 'react'

import Icon from '@/icons'
import BusinessSection from '@/business-section'

import './styles.css'

const SectionTailored = ({ gray }) => {
  return (
    <BusinessSection
      title="Tailored for your beauty pageant"
      subtitle="One turnkey solution for all your needs"
      gray={gray}
    >
      <div className="flex flex-wrap justify-center mw560 center">
        <Item icon="articles" text="Articles" />
        <Item icon="voting" text="Voting" />
        <Item icon="rating" text="Rating" />
        <Item icon="poll" text="Poll" />
        <Item icon="react" text="React" />
        <Item icon="challenge" text="Challenge" />
        <Item icon="casting" text="Casting" />
        <Item icon="battle" text="Battle" />
        <Item icon="swipe" text="Swipe" />
        <Item icon="shop" text="Shop" />
        <Item icon="br-button" text="Branded button" />
        <Item icon="lead" text="Lead capture" />
        <Item icon="optimized" text="Optimized for millions of users" />
        <Item icon="fast-loading" text="Fast loading" />
        <Item icon="optimization" text="Global server optimization" />
      </div>
    </BusinessSection>
  )
}

function Item({ icon, text }) {
  return (
    <div className="mb4 mh2 w100 h100 bg-light-gray br4 pv2 ph1 flex flex-column tc">
      <div className="tc flex-grow-1 flex items-center justify-center">
        <Icon icon={icon} width="auto" height="30px" className="mw60" />
      </div>
      <div className="f12 min-h26 flex flex-column justify-center">
        {text}
      </div>
    </div>
  )
}

export default SectionTailored



// WEBPACK FOOTER //
// ./src/components/section-tailored/section-tailored.js